// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListStyles } from "@eisinc/Overrides/Widgets/MyListsDetails/MyListsDetailsProductList";
import { color, modalButtonsActionStyles } from "@eisinc/XDL/Utilities";
import Move from "@insite/mobius/Icons/Move";
import { css } from "styled-components";

productListStyles.container = {
    gap: 0,
    css: css`
        /* Note: below line is to prevent a weird behavior where chrome wants to print anything that will fit
            * comprehensively on a single page on that page, which means the product list appears on page 2
            when rendering a common 8-item list with no notes. That's not ideal, so we're arbitrarily making
            the component large enough that it won't fit on a single page. */
        @media print {
            padding-bottom: 120px;
        }
    `,
};

productListStyles.lineGridItem = {
    width: 12,
    css: css`
        padding: 12px 5px;
        padding-block: 12px;
        border-bottom: 1px solid ${color("common.ui3")};
        &:last-child {
            margin-bottom: 30px !important;
        }
        &:first-child {
            border-top: 1px solid ${color("common.ui3")};
        }
    `,
};

productListStyles.editNotesModalButtonsWrapper = {
    css: css`
        @media print {
            display: none;
        }
        ${modalButtonsActionStyles.buttonsGridItem?.css}
        margin-top: 16px;
    `,
};

productListStyles.editNotesModalCancelButton = { ...modalButtonsActionStyles.cancelButton };

productListStyles.editNotesModalSubmitButton = { ...modalButtonsActionStyles.submitButton };

productListStyles.twoButtonModalStyles = {
    cancelButton: {
        ...modalButtonsActionStyles.cancelButton,
    },
    submitButton: {
        ...modalButtonsActionStyles.submitButton,
    },
    buttonsGridItem: {
        ...modalButtonsActionStyles.buttonsGridItem,
    },
};
productListStyles.dragHandleIcon = {
    src: Move,
    size: 22,
    css: css`
        cursor: move;
        touch-action: none;
    `,
};
